import React, { ReactNode, createContext } from 'react';

export const ViewTemplateContext = createContext<MBAPI.ViewTemplate | null>(null);

interface Props {
  template: MBAPI.ViewTemplate | null;
  children: ReactNode;
}

export function BlockViewTemplateProvider({ template, children }: Props) {
  return <ViewTemplateContext.Provider value={template}>{children}</ViewTemplateContext.Provider>;
}
